import { render } from "./MortgageProtectionAnalysis.vue?vue&type=template&id=4e7b2ae6&scoped=true"
import script from "./MortgageProtectionAnalysis.vue?vue&type=script&lang=js"
export * from "./MortgageProtectionAnalysis.vue?vue&type=script&lang=js"

import "./MortgageProtectionAnalysis.vue?vue&type=style&index=0&id=4e7b2ae6&lang=css"
import "./MortgageProtectionAnalysis.vue?vue&type=style&index=1&id=4e7b2ae6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7b2ae6"]])

export default __exports__